import { Flex, FormLabel, Text } from "@chakra-ui/react";
import { useField } from "formik";
import { SelectControl, SwitchControl } from "formik-chakra-ui";
import React, { useMemo } from "react";
import useCheckUserRole from "src/hooks/useCheckUserRole";

const PermissionLevels = [
  { label: "District Admin", value: "district-admin" },
  { label: "Org Admin", value: "org-admin" },
  { label: "School Admin", value: "school-admin" },
];
type Props = { name: string };
export const PermissionLevel: React.FC<Props> = ({ name }) => {
  const [switchField] = useField("permissionLevelSwitch");
  const [, , fieldHelpers] = useField(name);
  const { isAvelaAdmin, isOrgAdmin, isDistrictAdmin, isSchoolAdmin } =
    useCheckUserRole();
  const permissions = useMemo(() => {
    if (isAvelaAdmin) {
      return PermissionLevels;
    }
    if (isOrgAdmin) {
      return PermissionLevels.filter((level) => level.value !== "admin");
    }
    if (isDistrictAdmin) {
      return PermissionLevels.filter((level) =>
        ["district-admin", "school-admin"].includes(level.value)
      );
    }
    if (isSchoolAdmin) {
      return PermissionLevels.filter((level) => level.value === "school-admin");
    }
    return [];
  }, [isAvelaAdmin, isDistrictAdmin, isOrgAdmin, isSchoolAdmin]);

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.checked) {
      fieldHelpers.setValue("");
    }
    switchField.onChange(event);
  };

  return (
    <Flex alignItems="start" mt="2" mb="6" direction="row" gap="2">
      <SwitchControl name="permissionLevelSwitch" onChange={onChangeHandler} />
      <Flex direction="column">
        <Text>Internal-only</Text>
        <Text fontSize="xs" color="gray.600" fontWeight="400">
          When enabled, it will not be displayed to parents.
        </Text>
        {switchField.value && (
          <Flex gap="0.5" paddingTop="2" direction="column">
            <FormLabel htmlFor={name}>Permission level</FormLabel>
            <SelectControl
              selectProps={{ placeholder: "Select a permission level" }}
              name={name}
            >
              {permissions.map((option) => {
                return (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                );
              })}
            </SelectControl>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
